module.exports = __webpack_public_path__ + "img/en_grid-edition.40b92989.png";